module.exports = __webpack_public_path__ + "static/pc_mb_casestudy_holdsport-b166bf88ee8e3bb9bda718bd8d84d15d.jpg";